$.widget("EASY.toggleable" , $.EASY.Widget, {
  // Name is there for developers comfort especially in error reporting
  name:"Click on click out",

  content: null,

  observer: null,

  state: null,

  /**
   * Initially set to null, this property stores a reference to the nearest focusable element
   * that triggered the dropdown. When the dropdown is closed, the focus can be returned to this stored element.
   * @type {Object|null}
   */
  lastTriggerButton: null,

  /**
   * If widget should store its state in local storage, and restore it on next page load.
   * It's gained from options.storeState.
   * @type {boolean|null}
   */
  storeState: null,

  localStorageKey: "easy-toggleable-state",

  /**
   * Initialize the toggleable widget.
   */
  _customInit: function() {
    var self = this;

    self.state = false;
    self.content = self.options.content || $(this.element.attr("data-widget-content"));
    self.trigger = self.options.trigger;
    self.avoid = self.options.avoid;
    self.ignore = self.options.ignore;
    self.observer = self.options.observer || EASY.defaultClickObserver;
    self.openCallback = self.options.openCallback;
    self.closeCallback = self.options.closeCallback;
    self.storeState = self.options.storeState;

    if(self.observer) self.observer.addClickTarget(self);
    if(self.trigger) self.$triggerElement = $(self.trigger);
    if(self.content) self.$contentElement = $(self.content);

    self.element.addClass('w-toggleable');

    var element = self._getElement();

    element.click( function( event ){
      event = event || window.event; // use the value of event if available or if not assume it's IE and use window.event
      self.observer.reportEvent(event);
      self.lastTriggerButton = self._getFocusableTrigger(event.target);
      if(!self.state){
        if(!$(event.target).is(self.avoid) && !(self.$contentElement[0] && $.contains( self.$contentElement[0], event.target))) {
          self._open();
          return false;
        }
      }else{
        if (!$(event.target).closest(self.$contentElement).length) {
          self._close();
        }
      }
    });

    if(self.storeState) self._restoreStateFromLocalStorage();

    /**
     * Establishes a keydown event handler on the entire `self.$contentElement` while the dropdown is toggleable.
     * If the 'Escape' key is pressed (keyCode 27), the dropdown is closed by calling 'self._close()'.
     * If there was a trigger button that opened the dropdown and caused the focus to shift
     * to the dropdown, the focus is moved back to that trigger button.
     */
    const contentElement = self.$contentElement;

    contentElement.on('keydown.toggleable', function(event) {
      if (event.key === 'Escape' || event.key === 'Tab' && self._isLastElementFocused(contentElement.find('a, button, [tabindex]:not([tabindex="-1"])'))) {
        event.stopPropagation();
        if (self.lastTriggerButton !== null) {
          self.lastTriggerButton.focus({ focusVisible: true });
        }
        self._close();
      }
    });
  },

  clickOutCallback: function ( event ){
    var self = this;
    if( self.state ){
      var element = self.content ? $(self.content) : self.element;
      element.each(function(item){
        requestAnimationFrame(function(){
          if(
              self.state &&
              !$(self.content).find(event.target).length &&
              !$(event.target).data("not-toggleable-close") &&
              !$(event.target).is(self.ignore) &&
              !$(event.target).parents().is(self.ignore) &&
              !$(event.target).parents().is(self.content)
          ){
            self._close();
          };
        });
      })
    }
  },

  _setDirectionProps: function(element){
    const bounds = element.getBoundingClientRect();
    const viewHeight = (window.innerHeight || document.documentElement.clientHeight);
    let maxHeightBase = viewHeight - bounds.top;

    if (bounds.top > viewHeight - bounds.top) {
      element.classList.add('u-reversed');
      maxHeightBase = bounds.top;
    }

    element.style.maxHeight = `calc(${Math.round(maxHeightBase)}px - var(--easy__spacing--base))`;
    element.style.overflow = "overlay";
  },

  /**
   * Opens the toggleable element by setting the necessary classes and attributes.
   * This method activates the toggleable element, sets direction properties, updates aria-expanded attributes,
   * and manages the state in local storage if necessary.
   * @private
   * @returns {void}
   */
  _open: function () {
    const self = this;
    const element = self._getElement();

    self._activateElements();
    self._toggleAriaExpanded(element[0]);
    self._toggleState();
    if (self.storeState) self._storeStateToLocalStorage();
    if (self.openCallback) self.openCallback();
  },

  /**
   * Activates the main toggleable element, trigger element, and content element.
   * @private
   * @returns {void}
   * */
  _activateElements: function () {
    const self = this;

    self.element.addClass('w-toggleable--active');

    if (this.trigger) {
      this.$triggerElement.addClass('w-toggleable__trigger--active u-active');
    }

    if (this.content && this.$contentElement[0]) {
      this.$contentElement.addClass('w-toggleable__content--active u-active');
      this._setDirectionProps(this.$contentElement[0]);
    }
  },

  _close: function () {
    var self = this;
    var element = self._getElement();
    self._toggleAriaExpanded(element[0]);
    self._cleanup();
    self._toggleState();
    this.lastTriggerButton = null;
    if (self.storeState) this._storeStateToLocalStorage();
    if (self.closeCallback) self.closeCallback();
  },

  _cleanup: function(){
    var self = this;
    self.element.removeClass('w-toggleable--active');
    if(self.trigger) self.$triggerElement.removeClass('w-toggleable__trigger--active u-active');
    if(self.content && self.$contentElement[0]){
      self.$contentElement.removeClass('w-toggleable__content--active u-active u-reversed');
      self.$contentElement[0].style.removeProperty('max-height');
    }
  },

  _customDestroy: function(){
    var self = this;
    self._cleanup();
    $(document).off('keydown.toggleable');
  },


  _getFocusableTrigger: function(target) {
    const element = this._getElement()[0];
    const selector = 'a, button, [tabindex]:not([tabindex="-1"])';
    const closestTrigger = $(target).closest(selector, element)[0];

    if (closestTrigger) return closestTrigger;
    if (this._isFocusable(element)) return element;

    return element.querySelector(selector);
  },

  /**
   * Toggles the aria-expanded attribute of the provided element or its focusable child.
   * @param {HTMLElement} element - The element to toggle the aria-expanded attribute for.
   * @private
   * @returns {void}
   */
  _toggleAriaExpanded(element) {
    const isElementFocusable = this._isFocusable(element);

    if (isElementFocusable) {
      element.setAttribute('aria-expanded', element.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    } else {
      const focusableChild = element.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
      if (focusableChild) {
        focusableChild.setAttribute(
          'aria-expanded',
          focusableChild.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
        );
      }
    }
  },

  /**
   * Checks if the provided element is focusable.
   * @param {HTMLElement} element - The element to check for focusability.
   * @private
   * @returns {boolean} Returns true if the element is focusable, otherwise false.
   */
  _isFocusable(element) {
    if (element.hasAttribute('tabindex') && element.getAttribute('tabindex') !== '-1') {
      return true;
    }

    return element.tagName.toLowerCase() === 'a' || element.tagName.toLowerCase() === 'button';
  },

  /**
   * Checks if the last focusable element in the provided list is currently focused.
   * A focusable element is considered to be an element that is not hidden.
   *
   * @param {NodeListOf<Element>} linkElements - A list of potential focusable elements.
   * @returns {boolean} Returns true if the last focusable element is currently focused, otherwise false.
   */
  _isLastElementFocused(linkElements) {
    const focusableElements = Array.from(linkElements).filter(element => !this._isHidden(element));
    const lastElement = focusableElements[focusableElements.length - 1];
    if (document?.activeElement) {
      return document.activeElement === lastElement;
    } else {
      return false;
    }
  },

  /**
   * Checks if the provided element is hidden.
   * An element is considered hidden if it has no offset parent or if its offsetWidth or offsetHeight is 0.
   *
   * @param {HTMLElement} element - The element to check for visibility.
   * @returns {boolean} Returns true if the element is hidden, otherwise false.
   */
  _isHidden(element) {
    return element.offsetParent === null || element.offsetWidth === 0 || element.offsetHeight === 0;
  },

  /**
   * Return jQuery instance of trigger element or widget element
   * @returns {jQuery}
   * @private
   */
  _getElement: function() {
    return this.trigger ? this.$triggerElement : $(this.element);
  },

  _getElementId: function() {
    return this._getElement().attr('id');
  },

  /**
   * Return object where keys are element ids and values are states
   * @returns {Object}
   * @private
   */
  _getStatesFromLocalStorage: function() {
    return JSON.parse(localStorage.getItem(this.localStorageKey) || "{}");
  },

  /**
   * Return state of element from local storage or undefined if element has no id
   * @returns {boolean|undefined}
   * @private
   */
  _getStateFromLocalStorage: function() {
    if (!this._getElementId()) return undefined;
    const states = this._getStatesFromLocalStorage();
    return states[this._getElementId()];
  },

  /**
   * Store state to local storage, if element has no id, do nothing
   * @private
   */
  _storeStateToLocalStorage: function() {
    if (!this._getElementId()) return;
    const states = this._getStatesFromLocalStorage();
    states[this._getElementId()] = this.state;
      localStorage.setItem(this.localStorageKey, JSON.stringify(states));
  },

  /**
   * Get state from local storage and toggle if state is different then current state,
   * if element has no id, do nothing
   * @private
   */
  _restoreStateFromLocalStorage: function() {
    if (!this._getElementId()) {
      return;
    }
    const state = this._getStateFromLocalStorage();
    if (this.state !== state) {
      this._getElement().click();
    }
  },
});

EASY.schedule.late(function () {
  $('[data-widget~=toggleable]').each(function(){
    var $this = $(this);
    $this.toggleable({observer: EASY.defaultClickObserver, content: $($this.attr('data-widget-content'))});
  })
});
